<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <app-header-nav></app-header-nav>

  <mat-toolbar class="border-b bg-white shadow-sm">
    <button mat-icon-button (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="text-xl font-semibold text-gray-800 ml-4">Payment Processing</h1>
    <span class="flex-auto"></span>
    <button mat-raised-button color="primary" (click)="openProcessPaymentDialog()">
      <mat-icon>credit_card</mat-icon> Process Payment
    </button>
  </mat-toolbar>

  <div class="p-6 space-y-6" *ngIf="!isLoading">
    <!-- Overview Cards -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Total Revenue</mat-card-title>
          <mat-icon class="text-green-500">trending_up</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold text-green-500">${{ getTotalRevenue() }}</div>
          <p class="text-xs text-gray-600">Today's total</p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Total Tips</mat-card-title>
          <mat-icon class="text-blue-500">attach_money</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold text-blue-500">${{ getTotalTips() }}</div>
          <p class="text-xs text-gray-600">Staff tips</p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Transactions</mat-card-title>
          <mat-icon class="text-gray-500">receipt</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold">{{ getTotalTransactions() }}</div>
          <p class="text-xs text-gray-600">Total processed</p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Pending</mat-card-title>
          <mat-icon class="text-orange-500">warning</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold text-orange-500">{{ getPendingPayments() }}</div>
          <p class="text-xs text-gray-600">Needs attention</p>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Tabs -->
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
      <mat-tab [label]="'All Payments (' + stats.totalTransactions + ')'">
        <div class="mt-4">
          <mat-card>
            <div class="mat-elevation-z2 rounded-lg overflow-hidden">
              <table mat-table [dataSource]="dataSource" matSort class="w-full">
                <!-- Payment ID Column -->
                <ng-container matColumnDef="paymentId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment ID </th>
                  <td mat-cell *matCellDef="let payment">{{ payment.transactionId || payment.id }}</td>
                </ng-container>

                <!-- Order ID Column -->
                <ng-container matColumnDef="orderId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Order ID </th>
                  <td mat-cell *matCellDef="let payment">{{ payment.orderId }}</td>
                </ng-container>

                <!-- Table Column -->
                <ng-container matColumnDef="table">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Table </th>
                  <td mat-cell *matCellDef="let payment">Order #{{ payment.orderId }}</td>
                </ng-container>

                <ng-container matColumnDef="customer">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer </th>
                  <td mat-cell *matCellDef="let payment">
                    {{ payment.orderId ? (customerNames.get(payment.orderId) || 'Loading...') : 'N/A' }}
                  </td>
                </ng-container>

                <!-- Amount Column -->
                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount </th>
                  <td mat-cell *matCellDef="let payment">
                    <div>
                      <div>\${{ payment.amount.toFixed(2) }}</div>
                      <!-- Tip not available in model -->
                    </div>
                  </td>
                </ng-container>

                <!-- Method Column -->
                <ng-container matColumnDef="method">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Method </th>
                  <td mat-cell *matCellDef="let payment">
                    <mat-chip [color]="getMethodColor(payment.paymentMethod)">
                      <div class="flex items-center gap-2">
                        <mat-icon class="text-sm">{{ getMethodIcon(payment.paymentMethod) }}</mat-icon>
                        {{ payment.paymentMethod }}
                      </div>
                    </mat-chip>
                  </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                  <td mat-cell *matCellDef="let payment">
                    <mat-chip [color]="getStatusColor(payment.status)">
                      <div class="flex items-center gap-2">
                        <mat-icon class="text-sm">{{ getStatusIcon(payment.status) }}</mat-icon>
                        {{ payment.status }}
                      </div>
                    </mat-chip>
                  </td>
                </ng-container>

                <!-- Time Column -->
                <ng-container matColumnDef="time">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Time </th>
                  <td mat-cell *matCellDef="let payment">{{ payment.createdAt | date:'short' }}</td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Actions </th>
                  <td mat-cell *matCellDef="let payment">
                    <div class="flex gap-1">
                      <button mat-icon-button (click)="viewPaymentDetail(payment); $event.stopPropagation()">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button mat-icon-button
                        (click)="updatePaymentStatus(payment, 'COMPLETED'); $event.stopPropagation()"
                        *ngIf="payment.status === 'PENDING'">
                        <mat-icon>check_circle</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" (click)="refundPayment(payment); $event.stopPropagation()"
                        *ngIf="payment.status === 'COMPLETED'">
                        <mat-icon>undo</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="cursor-pointer"
                  (click)="viewPaymentDetail(row)"></tr>
              </table>

              <mat-paginator [length]="stats.totalTransactions" [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 25, 100,300]" aria-label="Select page of payments"
                (page)="onPageChange($event)"></mat-paginator>
            </div>
          </mat-card>
        </div>
      </mat-tab>

      <mat-tab [label]="'Pending (' + (stats.statusCounts?.PENDING || stats.statusCounts?.pending || 0) + ')'">
        <div class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <mat-card *ngFor="let payment of getPaymentsByStatus('PENDING')" class="border-orange-200">
              <mat-card-header>
                <mat-card-title class="flex items-center justify-between">
                  <span>{{ payment.transactionId || payment.id }}</span>
                  <mat-chip color="warn">PENDING</mat-chip>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content class="space-y-2">
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Order:</span>
                  <span>{{ payment.orderId }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Amount:</span>
                  <span class="font-semibold">\${{ payment.amount.toFixed(2) }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Method:</span>
                  <span>{{ payment.paymentMethod }}</span>
                </div>
                <div class="flex gap-2 mt-3">
                  <button mat-raised-button color="primary" (click)="updatePaymentStatus(payment, 'COMPLETED')">
                    <mat-icon>check_circle</mat-icon>
                    Complete
                  </button>
                  <button mat-stroked-button (click)="viewPaymentDetail(payment)">
                    <mat-icon>visibility</mat-icon>
                    View Details
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
            <!-- Show placeholder if no payments found for this tab -->
            <div *ngIf="getPaymentsByStatus('PENDING').length === 0"
              class="col-span-full text-center py-8 text-gray-500">
              No pending payments found.
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab [label]="'Completed (' + (stats.statusCounts?.COMPLETED || stats.statusCounts?.completed || 0) + ')'">
        <div class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <mat-card *ngFor="let payment of getPaymentsByStatus('COMPLETED')" class="border-green-200">
              <mat-card-header>
                <mat-card-title class="flex items-center justify-between">
                  <span>{{ payment.transactionId || payment.id }}</span>
                  <mat-chip color="primary">COMPLETED</mat-chip>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content class="space-y-2">
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Order:</span>
                  <span>{{ payment.orderId }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Amount:</span>
                  <span class="font-semibold">\${{ payment.amount.toFixed(2) }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Method:</span>
                  <span>{{ payment.paymentMethod }}</span>
                </div>
                <div class="flex gap-2 mt-3">
                  <button mat-raised-button color="warn" (click)="refundPayment(payment)">
                    <mat-icon>undo</mat-icon>
                    Refund
                  </button>
                  <button mat-stroked-button (click)="viewPaymentDetail(payment)">
                    <mat-icon>visibility</mat-icon>
                    View Details
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
            <div *ngIf="getPaymentsByStatus('COMPLETED').length === 0"
              class="col-span-full text-center py-8 text-gray-500">
              No completed payments found.
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab [label]="'Refunded (' + (stats.statusCounts?.REFUNDED || stats.statusCounts?.refunded || 0) + ')'">
        <div class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <mat-card *ngFor="let payment of getPaymentsByStatus('REFUNDED')" class="border-red-200">
              <mat-card-header>
                <mat-card-title class="flex items-center justify-between">
                  <span>{{ payment.transactionId || payment.id }}</span>
                  <mat-chip color="warn">REFUNDED</mat-chip>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content class="space-y-2">
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Order:</span>
                  <span>{{ payment.orderId }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Amount:</span>
                  <span class="font-semibold">\${{ payment.amount.toFixed(2) }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-sm text-gray-600">Method:</span>
                  <span>{{ payment.paymentMethod }}</span>
                </div>
                <div class="flex gap-2 mt-3">
                  <button mat-stroked-button (click)="viewPaymentDetail(payment)">
                    <mat-icon>visibility</mat-icon>
                    View Details
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
            <div *ngIf="getPaymentsByStatus('REFUNDED').length === 0"
              class="col-span-full text-center py-8 text-gray-500">
              No refunded payments found.
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="flex justify-center items-center h-screen" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>

  <!-- Footer -->
  <app-footer></app-footer>
</div>